import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import './styles.css';
import Icon from '../../../components/Icon';
import PropTypes from 'prop-types';

const messages = defineMessages({
  you: {
    id: 'hubs.overview.academic-match.you',
    defaultMessage: 'You',
  },
  yourHighSchool: {
    id: 'hubs.overview.academic-match.yourHighSchool',
    defaultMessage: "Your High School's {middle50} of Accepted Students",
  },
  national: {
    id: 'hubs.overview.academic-match.national',
    defaultMessage: 'National {middle50} of Enrolled Students',
  },
});

export const getYouIcon = (style) => {
  return (
    <Icon
      name="user circle"
      size="large"
      className="academic-match-legend-you"
      data-cy="academic-match-legend-you-icon"
      aria-label="legend icon representing your scores"
      style={style}
    />
  );
};

const AcademicMatchLegend = ({ intl }) => (
  <div className="academic-match-legend-container" data-cy="academic-match-legend">
    <div className="academic-match-legend">
      {getYouIcon()}
      <div
        className="academic-match-legend-text"
        data-cy="academic-match-legend-you-text"
      >
        <FormattedMessage {...messages.you} />
      </div>
    </div>
    <div className="academic-match-legend">
      <div className="academic-match-legend-icon">
        <Icon
          name="circle"
          size="big"
          className="academic-match-legend-your-high-school"
          data-cy="academic-match-legend-your-high-school-icon"
          aria-label="legend icon representing the scores of students from your high school"
        />
      </div>
      <div
        className="academic-match-legend-text"
        data-cy="academic-match-legend-your-high-school-text"
      >
        <FormattedMessage
          {...messages.yourHighSchool}
          values={{ middle50: <u>Middle 50%</u> }}
        />
      </div>
    </div>
    <div className="academic-match-legend">
      <div className="academic-match-legend-icon">
        <Icon
          name="circle"
          size="large"
          className="academic-match-legend-national"
          data-cy="academic-match-legend-national-icon"
          aria-label="legend icon representing scores from all students nationally"
        />
      </div>
      <div
        className="academic-match-legend-text"
        data-cy="academic-match-legend-national-text"
      >
        <FormattedMessage
          {...messages.national}
          values={{ middle50: <u>Middle 50%</u> }}
        />
      </div>
    </div>
  </div>
);

AcademicMatchLegend.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(AcademicMatchLegend);
